export const homeTexts = {
    en: {
        movingLeanManufacturing: {
            title: 'Moving lean manufacturing',
            slide1Name: 'VHGQ-D-9912',
            slide1Desc: 'He is assembling the forks inside one double-chamber high pressure gas quenching furnace.',
            slide2Name: 'CW-446',
            slide2Desc: 'He is de-bugging a water washer besides one much bigger water washer and another solvent cleaning machine.',
            slide3Name: 'Design, Assemble,',
            slide3NameBr: 'Debug, Test',
            slide3Desc: 'Every machine is delivered to customer before fully scheduled manufacture, which is complied with the Quality System Certification.',
            more: 'MORE'
        },

        technology: {
            solution: 'Solution',
            manufacture: 'Manufacture',
            service: 'Service',
            processList1: '｜ Heat Treating ｜ Surface Engineering',
            processList2: '｜ Hot Isostatic Pressing ｜ Metal Joining',
            processList3: '｜ Testing & Analysis ｜ Surface Cleaning',
            heatTreatingTitle: 'Heat Treating',
            heatTreatingDesc: 'Annealing, normalizing, quenching and tempering',
            cleaningTitle: 'Cleaning',
            cleaningDesc: 'High quality industrial cleaning by water, solvent',
            nitridingTitle: 'Nitriding',
            nitridingDesc: 'Evacuated, plasma, controllable nitriding and nitrocarburizing',
            brazingTitle: 'Brazing',
            brazingDesc: 'High vacuum system working, for super alloys, ceramics, etc.',
            coatingTitle: 'Coating',
            coatingDesc: 'PVD, CVD, thermal spraying, laser cladding, etc.'
        },

        movingInnovation: {
            title: 'Moving innovation forward',
            slide1Name: 'LPC',
            slide1Line1: 'Vacuum Carburizing',
            slide1Line2: 'Production Line',
            slide2Name: 'SOLVACS S',
            slide2Line1: 'Vacuum Solvent',
            slide2Line2: 'Tube Cleaning Machine',
            more: 'MORE'
        },

        news: {
            title1: 'Information',
            title2: '& News',
            item1Title: 'Exhibition and Congress • August 20, 2025',
            item1Desc: 'SAMT participated World Congress on Heat Treatment and Surface Engineering, held every four years and organized by the International Federation of Heat Treatment and Surface Engineering (IFHTSE), at the Suzhou Lion Mountain Conference Center.',
            item2Title: 'Control and Softwares • October 31, 2025',
            item2Desc: 'Adding process management, automatic production scheduling, digital twin, equipment management, data analysis and reporting capabilities to the existing work order management, batch management, production management, and quality management systems.',
            item3Title: 'Equipment and Process • November 21, 2025',
            item3Desc: 'The equipment for special alloy melting and precision casting has completed the first casting mold at the Shaoxing testing plant.'
        },

        aboutUs: {
            pageTitle: 'About SAMT',
            title: 'ABOUT SAMT',
            ourHistory: 'OUR HISTORY',
            historyP1: 'One excellence team consisting of senior metallurgist sponsored to create the consulting business for the application of materials and metallurgy in Shanghai at the spring of year 2009. The company was named as SAMT.',
            historyP2: 'SAMT team had the career background of the steel metallurgy company, and profession on heat treatment and surface engineering of metal materials. We have the vision to develop SAMT as the system supplier who independently own the core technology of materials and metallurgy, and keep the world-advanced leading position by the consistent innovation.',
            companyUpdateTitle: 'COMPANY UPDATE',
            iso9001: 'ISO 9001',
            isoDesc: 'Since 2011, SAMT has been running the German TÜV Rheinland ISO9001 quality system certification.',
            isoCertCnAlt: 'ISO certificate (CN)',
            isoCertEnAlt: 'ISO certificate (EN)',
            publicMarket: 'PUBLIC MARKET',
            publicMarketP1: 'In March 2015, SAMT (100431) was successfully listed on the Shanghai Stock Exchange Center (E Board). The company’s operation became more standardized, and banks as well as investment institutions further recognized its business model, industry prospects, and sustainable capabilities—marking a qualitative leap in development.',
            publicMarketP2: 'By the end of 2015, SAMT obtained the new code 300007 and upgraded to the Shanghai Science and Technology Innovation Board.',
            highTechPlaqueAlt: 'High tech certification plaque',
            highTechCertification: 'HIGH TECH CERTIFICATION',
            highTechDesc: 'SAMT has been recognized as a high-tech enterprise in Shanghai since late 2017.',
            highTechCertAlt: 'High tech enterprise certificate',
            visionMissionValuesTitle: 'OUR VISION, MISSION AND VALUES',
            visionTitle: 'VISION',
            visionDesc: 'To independently master the core technologies of materials and metallurgy in China, and to maintain a world-leading position through consistent innovation.',
            missionTitle: 'MISSION',
            missionDesc: 'Through "innovating technology at low cost and reducing cost through technological innovation", SAMT persists in continuously improving its capabilities and providing systems and solutions based on core material technologies, so as to reduce dependence on overseas companies and enhance the international competitiveness of our products.',
            valueTitle: 'VALUE',
            valueDesc: 'INTEGRITY, PRECISE, INNOVATION, TEAMWORK',
            partnershipTitle: 'PARTNERSHIP',
            partnershipDesc: 'SAMT maintains global contacts with metallurgical experts and companies, and partners with consulting firms from Europe and North America. SAMT integrates these resources to serve manufacturing companies in China.'
        },

        career: {
            pageTitle: 'Career | SAMT',
            bannerAlt: 'Work together with our team',
            bannerTitle: 'Career',
            introP1: 'We are looking for experienced engineers and workers in machinery designing, manufacture, production and qualification. A great team needs extraordinary work from each of us.',
            introP2: 'Young graduates who are passionate about their profession and willing to take the toughest challenges in manufacturing industries are also preferred. Our innovation culture can help you build a dynamic and rewarding career.',
            majorsTitle: 'Majors we are interested in:',
            major1: 'Physical Science',
            major2: 'Chemical Science',
            major3: 'Material Science and Engineering',
            major4: 'Mechanical Design and Construction',
            major5: 'Electrical and Automation',
            sendResumeTo: 'Send resume to',
            resumeEmail: 'hr@samtc.com'
        }
    },

    zh: {
        movingLeanManufacturing: {
            title: '我们精益制造',
            slide1Name: 'VHGQ-D-9912',
            slide1Desc: '他正在一台双室的高压气淬炉内安装转移叉臂。',
            slide2Name: 'CW-446',
            slide2Desc: '他正在调试一台水清洗机，旁边有一台大更多的水清洗机和另一台溶剂清洗机。',
            slide3Name: '设计，组装，调试，',
            slide3NameBr: '测试验收',
            slide3Desc: '每台机器在完全按照预定计划制造完成后才会交付给客户，这一过程符合质量体系认证标准。',
            more: '更多信息'
        },

        technology: {
            solution: '解决方案',
            manufacture: '制造',
            service: '服务',
            processList1: '｜ 热处理 ｜ 表面工程',
            processList2: '｜ 热等静压 ｜ 金属连接',
            processList3: '｜ 检测与分析 ｜ 表面清洗',
            heatTreatingTitle: '热处理',
            heatTreatingDesc: '金属的退火，正火，淬火和回火',
            cleaningTitle: '清洗',
            cleaningDesc: '高质量的工业清洗系统，使用水或溶剂作为清洗介质',
            nitridingTitle: '氮化炉',
            nitridingDesc: '预抽真空，等离子，可控的渗氮和氮碳共渗，氧化',
            brazingTitle: '钎焊',
            brazingDesc: '高真空系统配合，用于超合金，陶瓷，铝合金等',
            coatingTitle: '表面涂覆',
            coatingDesc: 'PVD，CVD，热喷涂，激光熔覆等'
        },

        movingInnovation: {
            title: '我们推动创新',
            slide1Name: 'LPC',
            slide1Line1: '真空渗碳',
            slide1Line2: '热处理生产线',
            slide2Name: 'SOLVACS S',
            slide2Line1: '真空溶剂',
            slide2Line2: '管材清洗机',
            more: '更多信息'
        },

        news: {
            title1: '资讯',
            title2: '& 新闻',
            item1Title: '行业展会及论坛 • 2025年8月20日',
            item1Desc: '先越在苏州狮山会议中心参加国际热处理与表面工程联合会IFHTSE主办的4年一届的世界热处理及表面工程大会。',
            item2Title: '管理软件功能 • 2025年10月31日',
            item2Desc: '在原有工单管理，批次管理，生产管理，质量管理的基础上增加工艺管理，自动排产，数字孪生，设备管理，数据分析与报表。',
            item3Title: '设备与工艺 • 2025年11月21日',
            item3Desc: '用于特殊合金熔炼和精密铸造的设备在绍兴测试工厂完成了场内首套浇铸模具试制。'
        },

        aboutUs: {
            pageTitle: '关于先越SAMT',
            title: '关于先越SAMT',
            ourHistory: '我们的开始',
            historyP1: '一个由冶金领域资深成员组成的专业团队，于2009年春天在上海创建了材料和冶金应用咨询业务。该公司被命名为先越。',
            historyP2: '先越团队成员拥有钢铁冶金企业从业背景，以及金属材料热处理和表面工程专业经验。我们的愿景是将先越发展成为具备材料与冶金关键技术能力的系统供应商，并以持续创新保持技术研发的前瞻性。',
            companyUpdateTitle: '公司更新',
            iso9001: 'ISO 9001',
            isoDesc: '⾃2011以来，先越⼀直在运⾏德国莱茵 TÜV ISO9001质量体系认证。',
            isoCertCnAlt: 'ISO 证书（中文）',
            isoCertEnAlt: 'ISO 证书（英文）',
            publicMarket: '公共市场',
            publicMarketP1: '2015年3⽉，先越技术(100431) 成功在上海证券交易所E板挂牌上市，公司经营更加规范; 银⾏和投资机构对经营模式、⾏业发展前景，特别是可持续经营能⼒获得进⼀步肯定，企业发展实现质的⻜跃。',
            publicMarketP2: '之后先越获得了新的代码300007，进入上海科创板。',
            highTechPlaqueAlt: '高新技术认证牌匾',
            highTechCertification: '高新技术企业认定',
            highTechDesc: '先越⾃2017年起在上海获得⾼新技术企业认证。',
            highTechCertAlt: '高新技术企业证书',
            visionMissionValuesTitle: '愿景、使命与价值观',
            visionTitle: '愿景',
            visionDesc: '中国⾃主拥有材料和冶⾦的核⼼技术，并持续创新保持行业前沿地位。',
            missionTitle: '使命',
            missionDesc: '“以低成本创新技术，以技术创新降低成本”先越坚持不断提⾼⾃⼰的能⼒，提供体系核⼼技术的体系和解决⽅案，以消除对外资企业的依赖，拥有参与国际化竞争⼒的产品。',
            valueTitle: '价值',
            valueDesc: '诚信，严谨，创新，团队精神',
            partnershipTitle: '合作伙伴',
            partnershipDesc: '先越与全球很多冶⾦专家和公司保持着联系，并与欧盟和北美多家咨询公司保持合作关系。为中国的制造企业集成全球资源是先越的目标。'
        },

        career: {
            pageTitle: '招贤纳士 | 先越SAMT',
            bannerAlt: '与我们的团队一起工作',
            bannerTitle: '职业发展',
            introP1: '我们正在寻找有经验的工程师和生产工人，在机械设计，制造，生产，品保控制等领域。一个伟大的团队来源于我们每一个人的出色工作。',
            introP2: '衷于专业、对制造业敢于接受挑战的年轻毕业生，也是我们的潜在伙伴。我们的创新文化可以帮助你建立一个充满活力和有益的职业生涯。',
            majorsTitle: '我们关注的专业和方向：',
            major1: '物理',
            major2: '化学',
            major3: '材料科学与工程',
            major4: '机械设计与制造',
            major5: '电气与自动化',
            sendResumeTo: '将简历投递到',
            resumeEmail: 'hr@samtc.com'
        }
    }
}

export const getHomeTexts = (lang) => {
    return homeTexts[lang] || homeTexts['en']
}